import React from 'react';
import { GenericTableColumn } from '@ui-components/Table/GenericTable';
import { GenericTag } from '@ui-components/Tag/GenericTag';

export interface ClusterIAMPermission {
  permission: string;
  reflector1Enabled: boolean;
  reflector2Enabled: boolean;
}

export interface ClusterIAMResponse {
  reflector1: {
    id: number;
    name: string;
  };
  reflector2: {
    id: number;
    name: string;
  };
  permissions: ClusterIAMPermission[];
}

export const clusterIAMPermissionsColumns = (
  reflector1Name: string,
  reflector2Name: string
): GenericTableColumn<ClusterIAMPermission>[] => [
  {
    header: 'Permission',
    accessor: 'permission',
  },
  {
    header: reflector1Name,
    accessor: 'reflector1Enabled',
    renderCell: (row: ClusterIAMPermission) => (
      <GenericTag
        label={row.reflector1Enabled ? 'Allowed' : 'Denied'}
        variant={row.reflector1Enabled ? 'success' : 'error'}
      />
    ),
  },
  {
    header: reflector2Name,
    accessor: 'reflector2Enabled',
    renderCell: (row: ClusterIAMPermission) => (
      <GenericTag
        label={row.reflector2Enabled ? 'Allowed' : 'Denied'}
        variant={row.reflector2Enabled ? 'success' : 'error'}
      />
    ),
  },
  {
    header: 'Required',
    renderCell: () => (
      <GenericTag label="Yes" variant="default" />
    ),
  },
];
